// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* !important beats antd's higher-specificity \`.ant-drawer .ant-drawer-close\` rule. */
.ant-drawer-close {
    width: 44px !important;
    height: 44px !important;
}

@media (max-width: 767px) {
    .fullWidthOnMobile__Drawer-module--iHORa .ant-drawer-content-wrapper {
        width: 100% !important;
    }
}

.ant-drawer-close:focus-visible {
    outline-color: var(--color-focus-outline) !important;
    outline-offset: var(--focus-outline-offset-sm) !important;
}
`, "",{"version":3,"sources":["webpack://./vector/src/Drawer/Drawer.module.css"],"names":[],"mappings":"AAAA,qFAAqF;AACrF;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,oDAAoD;IACpD,yDAAyD;AAC7D","sourcesContent":["/* !important beats antd's higher-specificity `.ant-drawer .ant-drawer-close` rule. */\n:global(.ant-drawer-close) {\n    width: 44px !important;\n    height: 44px !important;\n}\n\n@media (max-width: 767px) {\n    .fullWidthOnMobile :global(.ant-drawer-content-wrapper) {\n        width: 100% !important;\n    }\n}\n\n:global(.ant-drawer-close):focus-visible {\n    outline-color: var(--color-focus-outline) !important;\n    outline-offset: var(--focus-outline-offset-sm) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullWidthOnMobile": `fullWidthOnMobile__Drawer-module--iHORa`
};
export default ___CSS_LOADER_EXPORT___;
